// TopNav global — HarpIALogo + NavLinks (Home, Dashboard) + CTA Simular agora
import { Link, NavLink } from "react-router-dom";
import { HarpIALogo } from "@/components/brand/HarpIALogo";
import styles from "./TopNav.module.css";

export function TopNav() {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand} aria-label="HarpIA — Início">
          <HarpIALogo size={18} />
        </Link>
        <nav className={styles.nav} aria-label="Navegação principal">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              [styles.link, isActive ? styles.active : ""].filter(Boolean).join(" ")
            }
          >
            Início
          </NavLink>
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              [styles.link, isActive ? styles.active : ""].filter(Boolean).join(" ")
            }
          >
            Painel
          </NavLink>
        </nav>
        <Link to="/wizard" className={styles.cta}>
          Simular agora
        </Link>
      </div>
    </header>
  );
}
